import { render, staticRenderFns } from "./LoginAnnouncementDialog.vue?vue&type=template&id=0c757da8&scoped=true"
import script from "./LoginAnnouncementDialog.vue?vue&type=script&lang=js"
export * from "./LoginAnnouncementDialog.vue?vue&type=script&lang=js"
import style0 from "./LoginAnnouncementDialog.vue?vue&type=style&index=0&id=0c757da8&prod&lang=less"
import style1 from "./LoginAnnouncementDialog.vue?vue&type=style&index=1&id=0c757da8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!D:\\Code\\ui\\comic_ai\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c757da8",
  null
  
)

export default component.exports